module.exports = __webpack_public_path__ + "static/media/visa.svg.0ec6fbb1.png";